import React from 'react'; 
import logo from './../assets/images/logo.svg'; 
import linkedinIcon from './../assets/icons/mdi_linkedin.svg';
import twitterIcon from './../assets/icons/prime_twitter.svg';
import instagramIcon from './../assets/icons/ri_instagram-fill.svg';
import './../App.css';

function Home() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />

        <div className="social-container">
          <a href="https://x.com/flyzen1897" className="social-btn" target="_blank" rel="noopener noreferrer">
            <img alt="twitter" src={twitterIcon} />
          </a>
          <a href="https://www.linkedin.com/company/flyzenapp/" className="social-btn" target="_blank" rel="noopener noreferrer">
            <img alt="linkedin" src={linkedinIcon} />
          </a>
          <a href="https://www.instagram.com/flyzen.app/" className="social-btn" target="_blank" rel="noopener noreferrer">
            <img alt="instagram" src={instagramIcon} />
          </a>
        </div>

        <h1 className="Heading">FlyZen is now on the App Store</h1>
        <p className="secondary">
          Say goodbye to flight anxiety. Our guided meditations, calming visuals, and real-time flight tools help you stay relaxed — from takeoff to landing.
        </p>

        <a
          href="https://apps.apple.com/ca/app/flyzen-fear-free-flying/id6657959093"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83"
            alt="Download on the App Store"
            style={{ height: '60px', marginTop: '20px' }}
          />
        </a>

        <div className="note-container">
          <p className="note">
            <span role="img" aria-label="crown">👑</span> First <span className="highlight">1000 users</span> will receive a <span className="highlight">1 Year Free</span> access to all upcoming features!
          </p>
        </div>

        <p className="Copyrights">© Copyrights 2025. FlyZen Inc.</p>
      </header>
    </div>
  );
}

export default Home;
